exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--5-1!../../../../node_modules/postcss-loader/lib/index.js??postcss!./typography.css"), undefined);
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--5-1!../../../../node_modules/postcss-loader/lib/index.js??postcss!./barItem.css"), undefined);

// module
exports.push([module.id, ".counter___counter___1_4qC {\n    color: white;\n    letter-spacing: 0.01em;\n    user-select: none;\n}", ""]);

// exports
exports.locals = {
	"counter": "counter___counter___1_4qC " + require("-!../../../../node_modules/css-loader/index.js??ref--5-1!../../../../node_modules/postcss-loader/lib/index.js??postcss!./typography.css").locals["special"] + " " + require("-!../../../../node_modules/css-loader/index.js??ref--5-1!../../../../node_modules/postcss-loader/lib/index.js??postcss!./barItem.css").locals["bar-item"] + ""
};